<template>
    <div class="base-rebate-apply" :class="{'apply-sp': $store.state.screen == 1}" @click="istrumpet = false">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">申请返利</div>
                <div class="service-img" @click="$router.push('/base-service')">
                    <img class="ser" src="~images/user_service.png" />
                </div>
            </div>
            <div class="content-auto">
                <div class="list" @click.stop="onOpen">
                    <div class="name">充值小号</div>
                    <div>
                        <input class="con" type="text" readonly placeholder="请选择充值的小号" v-model="numName" />
                    </div>
                    <img class="bottom-img" src="~images/bottom.png" />
                    <transition name="component-fade" mode="out-in">
                        <div class="sel" v-if="istrumpet" @click.stop>
                            <div class="it" v-for="(item, index) in list" :key="index" @click="selTrumpet(item)">{{item.nick_name}}</div>
                        </div>
                    </transition>
                </div>
                <div class="list">
                    <div class="name">充值时间</div>
                    <div class="con">2020-08-27   10:33</div>
                </div>
                <div class="list">
                    <div class="name">充值金额</div>
                    <div class="con">50元</div>
                </div>
                <div class="list">
                    <div class="name">角色名称</div>
                    <input class="con" type="text" placeholder="需与游戏内角色名一致" >
                </div>
                <div class="list">
                    <div class="name">角色ID</div>
                    <input class="con" type="text" placeholder="请输入角色的专属识别编号" >
                </div>
                <div class="textlist">
                    <div class="name">备注(选填)</div>
                    <div class="content" v-if="istrue">
                        请输入50字以内的备注<br />
                        1、有道具奖励时，必须填写；<br />
                        2、道具奖励需要选择时，请填写你选择的奖励内容；<br />
                        3、填错或者瞎填会导致返利发放失败。
                    </div>
                    <textarea class="contentext" type="text" v-model="val" @input="descInput" />
                </div>
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn">提交申请</div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseRebateApply',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                val: null,
                istrue: true,
                list: [],
                istrumpet: false,
                numName: ''
            }
        },
        methods: {
            descInput () {
                if (this.val.replace(/\s*/g, "")) {
                    this.istrue = false
                } else {
                    this.istrue = true
                }
            },
            onOpen () {
                if (this.list.length > 0) {
                    this.istrumpet = !this.istrumpet
                } else {
                    this.msg = '暂无小号'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            },
            selTrumpet (item) {
                this.numName = item.nick_name
                this.istrumpet = false
            },
            // 获取小号列表
            getList () {
                let options = {
                    uid: this.accountData.uid,
                    appid: this.accountData.appid
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=app_user_list', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.list
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-rebate-apply {
        width: 1080px;
        height: 100%;
        padding-bottom: 60px;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
                .service-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .ser {
                        width: 72px;
                        height: 72px;
                    }
                }
            }
            .content-auto {
                flex: 1;
                overflow-y: scroll;
                padding: 60px;
                .list {
                    height: 120px;
                    border-radius: 18px;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    margin-bottom: 30px;
                    display: flex;
                    align-items: center;
                    position: relative;
                }
                .list .sel {
                    width: 650px;
                    max-height: 350px;
                    font-size: 39px;
                    border: 3px solid #eee;
                    background: #33363E;
                    padding: 0 30px 40px;
                    overflow-y: scroll;
                    position: absolute;
                    top: 120px;
                    right: 45px;
                    z-index: 2;
                }
                .list .sel .it{
                    margin-top: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .name {
                    width: 220px;
                    font-size: 42px;
                    margin-bottom: 5px;
                }
                .con {
                    flex: 1;
                    height: 120px;
                    font-size: 39px;
                    border: none;
                    outline: none;
                    background: none;
                    display: flex;
                    align-items: center;
                    color: #fff;
                }
                .bottom-img {
                    width: 30px;
                    height: 30px;
                    position: absolute;
                    right: 45px;
                }
                .textlist {
                    display: flex;
                    overflow: hidden;
                    height: 400px;
                    border-radius: 18px;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    position: relative;
                }
                .textlist .name {
                    width: 220px;
                    line-height: 120px;
                }
                .textlist .content {
                    width: 645px;
                    font-size: 39px;
                    color: #6D6E6F;
                    padding: 30px 0;
                    position: absolute;
                    right: 45px;
                }
                .contentext {
                    flex: 1;
                    height: 400px;
                    border: none;
                    background: none;
                    padding: 30px 0;
                    font-size: 39px;
                    outline: none;
                    resize: none;
                    position: relative;
                    z-index: 3;
                    color: #fff;
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .apply-sp {
        width: 100%;
        height: 100%;
        padding-bottom: 90px;
        .content {
            .header {
                height: 240px;
                border-radius: 60px 0 0 0;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
                .service-img {
                    width: 290px;
                    height: 240px;
                    .ser {
                        width: 130px;
                        height: 130px;
                    }
                }
            }
            .content-auto {
                padding: 90px;
                .list {
                    height: 200px;
                    border-radius: 32px;
                    padding: 0 70px;
                    margin-bottom: 54px;
                }
                .list .sel {
                    width: 900px;
                    max-height: 636px;
                    font-size: 60px;
                    border: 5px solid #eee;
                    padding: 0 54px 72px;
                    top: 200px;
                    right: 70px;
                }
                .list .sel .it{
                    margin-top: 72px;
                }
                .name {
                    width: 400px;
                    font-size: 76px;
                    margin-bottom: 9px;
                }
                .con {
                    height: 200px;
                    font-size: 60px;
                }
                .bottom-img {
                    width: 54px;
                    height: 54px;
                    right: 70px;
                }
                .textlist {
                    height: 727px;
                    border-radius: 32px;
                    padding: 0 70px;
                }
                .textlist .name {
                    width: 400px;
                    line-height: 200px;
                }
                .textlist .content {
                    width: 830px;
                    font-size: 60px;
                    padding: 54px 0;
                    right: 70px;
                }
                .contentext {
                    height: 727px;
                    padding: 54px 0;
                    font-size: 60px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px;
        }
    }
</style>